module.exports = __webpack_public_path__ + "static/media/arrow_right.450a5a13.svg";